// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Uq-z","imageAndVideoCount":"Vq-z","imageAndVideoContainer":"Wq-z","viewAllReviews":"Xq-z"};